"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var utils_exports = {};
__export(utils_exports, {
  findMessage: () => findMessage,
  findMessageInFiles: () => findMessageInFiles,
  loadMessageFromGroup: () => loadMessageFromGroup,
  matchNotification: () => matchNotification
});
module.exports = __toCommonJS(utils_exports);
var import_communication_shared = require("@hcengineering/communication-shared");
var import_communication_types = require("@hcengineering/communication-types");
var import_communication_yaml = require("@hcengineering/communication-yaml");
async function findMessage(client, workspace, filesUrl, card, id, created, reactions, attachments, replies) {
  const message = (await client.findMessages({ card, id, limit: 1, attachments, reactions, replies }))[0];
  if (message !== void 0) {
    return message;
  }
  return await findMessageInFiles(client, workspace, filesUrl, card, id, created);
}
__name(findMessage, "findMessage");
async function findMessageInFiles(client, workspace, filesUrl, card, id, created) {
  if (filesUrl === "") {
    return void 0;
  }
  const group = (await client.findMessagesGroups({
    card,
    fromDate: { lessOrEqual: created },
    toDate: { greaterOrEqual: created },
    limit: 1,
    order: import_communication_types.SortingOrder.Ascending,
    orderBy: "fromDate"
  }))[0];
  if (group === void 0) {
    return void 0;
  }
  try {
    const parsedFile = await (0, import_communication_yaml.loadGroupFile)(workspace, filesUrl, group.blobId, { retries: 3 });
    const messageFromFile = parsedFile.messages.find((it) => it.id === id);
    if (messageFromFile === void 0) {
      return void 0;
    }
    const patches = (group.patches ?? []).filter((it) => it.messageId === id);
    return patches.length > 0 ? (0, import_communication_shared.applyPatches)(messageFromFile, patches) : messageFromFile;
  } catch (e) {
    console.error("Failed to find message in files", { card, id, created });
    console.error("Error:", { error: e });
  }
}
__name(findMessageInFiles, "findMessageInFiles");
async function loadMessageFromGroup(id, workspace, filesUrl, blobId, patches = [], cache) {
  if (cache != null && cache.has(blobId)) {
    const parsedFile2 = await cache.get(blobId);
    if (parsedFile2 == null) return;
    const message2 = parsedFile2.messages.find((it) => it.id === id);
    if (message2 == null) return;
    return (0, import_communication_shared.applyPatches)(message2, patches);
  }
  const parsedFilePromise = (0, import_communication_yaml.loadGroupFile)(workspace, filesUrl, blobId, { retries: 3 });
  if (cache != null) {
    cache.set(blobId, parsedFilePromise);
  }
  const parsedFile = await parsedFilePromise;
  const message = parsedFile.messages.find((it) => it.id === id);
  if (message == null) return;
  return (0, import_communication_shared.applyPatches)(message, patches);
}
__name(loadMessageFromGroup, "loadMessageFromGroup");
function matchNotification(notification, params) {
  if (params.type !== void 0 && params.type !== notification.type) return false;
  if (params.read !== void 0 && params.read !== notification.read) return false;
  if (params.id !== void 0 && params.id !== notification.id) return false;
  if (params.context !== void 0 && params.context !== notification.contextId) return false;
  if (params.card !== void 0 && params.card !== notification.cardId) return false;
  const created = notification.created.getTime();
  if (params.created != null) {
    if (params.created instanceof Date) {
      if (created !== params.created.getTime()) return false;
    } else {
      const { greater, less, greaterOrEqual, lessOrEqual } = params.created;
      if (greater != null && created <= greater.getTime()) return false;
      if (less != null && created >= less.getTime()) return false;
      if (greaterOrEqual != null && created < greaterOrEqual.getTime()) return false;
      if (lessOrEqual != null && created > lessOrEqual.getTime()) return false;
    }
  }
  return true;
}
__name(matchNotification, "matchNotification");
//# sourceMappingURL=utils.js.map
